// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var Expln_React_Modal = require("@expln/utils/src/main/react-components/Expln_React_Modal.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;
var IconButton = require("@mui/material/IconButton").default;
var CancelOutlined = require("@mui/icons-material/CancelOutlined").default;

function rndProgress(text, pct, onTerminate, param) {
  return React.createElement(Paper, {
              style: {
                padding: Belt_Option.getWithDefault(Belt_Option.map(onTerminate, (function (param) {
                            return "5px";
                          })), "10px")
              },
              children: React.createElement(Expln_React_Row.make, {
                    alignItems: "center",
                    spacing: 1,
                    children: null
                  }, React.createElement("span", {
                        style: {
                          paddingLeft: "10px"
                        }
                      }, pct !== undefined ? "" + text + ": " + String(Math.round(pct * 100) | 0) + "%" : text), onTerminate !== undefined ? React.createElement(IconButton, {
                          onClick: (function (param) {
                              Curry._1(onTerminate, undefined);
                            }),
                          children: React.createElement(CancelOutlined, {})
                        }) : null)
            });
}

function openInfoDialog(modalRef, text, onOk, param) {
  Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
              return null;
            })), (function (modalId) {
          Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                  var onOk$1 = function (param) {
                    Expln_React_Modal.closeModal(modalRef, modalId);
                    Belt_Option.forEach(onOk, (function (clbk) {
                            Curry._1(clbk, undefined);
                          }));
                  };
                  return React.createElement(Paper, {
                              style: {
                                padding: "10px"
                              },
                              children: React.createElement(Expln_React_Column.make, {
                                    spacing: 1,
                                    children: null
                                  }, React.createElement("span", undefined, text), React.createElement(Button, {
                                        onClick: (function (param) {
                                            Curry._1(onOk$1, undefined);
                                          }),
                                        variant: "contained",
                                        children: "Ok"
                                      }))
                            });
                }));
        }));
}

function kbrdHnd(onCtrlEnter, onEnter, onEsc, param, kbrdEvt) {
  var isAlt = kbrdEvt.altKey;
  var isCtrl = kbrdEvt.ctrlKey;
  var isShift = kbrdEvt.shiftKey;
  var keyCode = kbrdEvt.keyCode;
  Belt_Option.forEach(onCtrlEnter, (function (onCtrlEnter) {
          if (!isAlt && isCtrl && !isShift && keyCode === 13) {
            return Curry._1(onCtrlEnter, undefined);
          }
          
        }));
  Belt_Option.forEach(onEnter, (function (onEnter) {
          if (!isAlt && !isCtrl && !isShift && keyCode === 13) {
            return Curry._1(onEnter, undefined);
          }
          
        }));
  Belt_Option.forEach(onEsc, (function (onEsc) {
          if (!isAlt && !isCtrl && !isShift && keyCode === 27) {
            return Curry._1(onEsc, undefined);
          }
          
        }));
}

exports.rndProgress = rndProgress;
exports.openInfoDialog = openInfoDialog;
exports.kbrdHnd = kbrdHnd;
/* react Not a pure module */
